export function ValidarCPF(_cpf: string) : boolean {
    let soma = 0;
    let resto;

    if(_cpf.length != 11) return false;
    if (_cpf == '00000000000') return false;

    for (let i = 1; i <= 9; i++)
        soma = soma + parseInt(_cpf.substring(i - 1, i)) * (11 - i);
    resto = (soma * 10) % 11;

    if (resto == 10 || resto == 11) resto = 0;
    if (resto != parseInt(_cpf.substring(9, 10))) return false;

    soma = 0;
    for (let i = 1; i <= 10; i++)
        soma = soma + parseInt(_cpf.substring(i - 1, i)) * (12 - i);
    resto = (soma * 10) % 11;

    if (resto == 10 || resto == 11) resto = 0;
    return resto == parseInt(_cpf.substring(10, 11));

}